import { GetMenuParams, MenuListResponse, PostMenuBody, UpdateMenuBody, MenuResponse } from 'services/security/interfaces/MenuInterface';
import { SecurityPathBuilder, SecurityPathsEnum, BuildUrlParams, APP_CODE } from 'services/Paths';
import api from 'services/Interceptor';

export const GetMenu = async (params: GetMenuParams = {}): Promise<MenuListResponse> => {
    let url = `${SecurityPathBuilder(SecurityPathsEnum.Menu)}`;
    const urlParams = BuildUrlParams(params as Record<string, string | string[] | undefined>);
    if (urlParams) {
        url += `?${urlParams}`;
    }
    const { data } = await api.get(url);
    return data;
};

export const PostMenu = async (body: PostMenuBody): Promise<MenuResponse> => {
    const url = SecurityPathBuilder(SecurityPathsEnum.Menu);
    const { data } = await api.post(url, body);
    return data;
};

export const UpdateMenu = async (iD: number, body: UpdateMenuBody): Promise<MenuResponse> => {
    const url = `${SecurityPathBuilder(SecurityPathsEnum.Menu)}/${iD}`;
    const { data } = await api.put(url, body);
    return data;
};

export const DeleteMenu = async (id: number): Promise<MenuResponse> => {
    const url = `${SecurityPathBuilder(SecurityPathsEnum.Menu)}/${id}`;
    const response = await api.delete(url);
    return response.data;
};

export const ActivateMenu = async (id: number): Promise<MenuResponse> => {
    const url = `${SecurityPathBuilder(SecurityPathsEnum.Menu)}/${id}/activate`;
    const response = await api.patch(url);
    return response.data;
};

export const GetUserMenu = async (): Promise<MenuListResponse> => {
    const url = `${SecurityPathBuilder(SecurityPathsEnum.Menu)}/user/${APP_CODE}`;
    const { data } = await api.get(url);
    return data;
};